// extracted by mini-css-extract-plugin
export default {"container":"home_container__5wttX","bodyElement":"home_bodyElement__kmYy0","faq":"home_faq__b5xxL","title":"home_title__qJOOZ","desc":"home_desc__GTJMe"};